var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestAppointment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 137,
    viewBox: "0 0 292 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455B76",
    d: "M225.541 129.774H90.134v-85.72c0-6.068 4.92-10.986 10.989-10.986h113.43c6.069 0 10.988 4.918 10.988 10.986v85.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M219.324 128.698H96.351V45.194a6.602 6.602 0 0 1 6.603-6.601h109.767a6.603 6.603 0 0 1 6.603 6.601v83.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8993A4",
    d: "M170.362 124.186v1.65a2.585 2.585 0 0 1-2.585 2.584h-19.878a2.585 2.585 0 0 1-2.585-2.584v-1.65h-65.27v6.65c0 2.5 2.027 4.526 4.528 4.526h146.532a4.527 4.527 0 0 0 4.528-4.527v-6.649h-65.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE3E6",
    d: "M84.572 135.362h146.532a4.528 4.528 0 0 0 4.528-4.527H80.044c0 2.5 2.027 4.527 4.528 4.527"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M209.494 51.107H109.052v-2.332c0-1.585 1.884-2.87 4.211-2.87h92.02c2.325 0 4.21 1.285 4.21 2.87v2.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF1",
    d: "M205.282 114.764h-92.019c-2.326 0-4.211-1.91-4.211-4.266V50.927h100.442v59.57c0 2.357-1.886 4.267-4.212 4.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M117.66 59.534h14.35V73.88h-14.35zM134.88 59.534h14.349V73.88h-14.35zM152.098 59.534h14.349V73.88h-14.35zM169.317 59.534h14.349V73.88h-14.35zM186.536 59.534h14.349V73.88h-14.35zM117.66 76.031h14.35v14.346h-14.35zM134.88 76.031h14.349v14.346h-14.35zM152.098 76.031h14.349v14.346h-14.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M169.317 76.031h14.349v14.346h-14.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M186.536 76.031h14.349v14.346h-14.35zM117.66 92.529h14.35v14.346h-14.35zM134.88 92.529h14.349v14.346h-14.35zM152.098 92.529h14.349v14.346h-14.35zM169.317 92.529h14.349v14.346h-14.35zM186.536 92.529h14.349v14.346h-14.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M44.2 113.356l-8.697 2.802a.735.735 0 0 1-.926-.925l2.803-8.696a36.185 36.185 0 0 1 23.345-23.34l8.697-2.802a.736.736 0 0 1 .926.926l-2.803 8.695a36.197 36.197 0 0 1-23.346 23.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M40.03 106.191l-4.167 8.13a.736.736 0 0 1-1.31 0l-4.167-8.13a36.175 36.175 0 0 1 0-33.007l4.168-8.13a.736.736 0 0 1 1.309 0l4.167 8.13a36.182 36.182 0 0 1 0 33.007"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M33.036 108.255l2.803 8.695a.735.735 0 0 1-.925.926l-8.698-2.802a36.197 36.197 0 0 1-23.345-23.34L.068 83.039a.736.736 0 0 1 .926-.926l8.697 2.802a36.192 36.192 0 0 1 23.345 23.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M42.126 136.43H26.954c-8.088 0-14.644-6.555-14.644-14.64v-10.27h44.46v10.27c0 8.085-6.556 14.64-14.644 14.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M34.54 111.52v24.91h7.586c8.088 0 14.644-6.555 14.644-14.64v-10.27H34.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8993A4",
    d: "M41.493 113.136v-7.822a3.848 3.848 0 0 1 3.848-3.848h9.06v-4.488h-9.798a7.695 7.695 0 0 0-7.695 7.694v9.105a7.694 7.694 0 0 0 7.695 7.693h9.798v-4.488h-9.06a3.847 3.847 0 0 1-3.848-3.846"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M79.222 136.262H55.553a6.25 6.25 0 0 1-6.25-6.249V96.978h36.17v33.035a6.25 6.25 0 0 1-6.251 6.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M74.976 117.152h1.057v-20.75h-1.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M71.756 122.047h7.08v-11.19h-7.08zM71.673.045H104.3c.467 0 .846.378.846.846V27.75c0 .158-.18.248-.307.154l-5.427-4.049h-27.74a.847.847 0 0 1-.847-.846V.89c0-.468.38-.846.847-.846"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.443 5.757c-1.896.02-3.153 1.744-3.291 1.972-.138-.228-1.395-1.951-3.29-1.972-3.708-.041-5.603 4.417-2.178 8.4 2.089 2.43 5.468 3.705 5.468 3.705s3.38-1.274 5.468-3.705c3.425-3.983 1.53-8.441-2.177-8.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M266.416 84.068a.944.944 0 0 1-.944-.943v-4.092a.944.944 0 0 1 1.887 0v4.092c0 .52-.422.943-.943.943"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M252.234 88.932a.998.998 0 0 1-1.393-.227l-6.949-9.65a.998.998 0 1 1 1.62-1.166l6.948 9.65a.997.997 0 0 1-.226 1.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#768D9B",
    d: "M249.087 134.705a1.115 1.115 0 0 1-.645-1.44l4.151-7.72 2.085.796-4.151 7.719c-.22.575-.865.864-1.44.645M283.827 134.705c.576-.22.865-.864.645-1.44l-4.35-7.72-2.086.796 4.351 7.719c.22.575.865.864 1.44.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M243.347 93.38l.416-.558A30.352 30.352 0 0 1 260.02 81.73l.005-.013c-3.163-4.828-9.664-6.056-14.361-2.774-4.698 3.282-5.778 9.808-2.33 14.437h.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M279.941 88.932a.998.998 0 0 0 1.393-.227l6.949-9.65a.998.998 0 1 0-1.62-1.166l-6.948 9.65a.997.997 0 0 0 .226 1.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M288.828 93.38l-.416-.558a30.352 30.352 0 0 0-16.256-11.092l-.005-.013c3.163-4.828 9.664-6.056 14.361-2.774 4.698 3.282 5.778 9.808 2.33 14.437h-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A7D88",
    d: "M291.521 108.166c0 13.862-11.24 25.1-25.105 25.1s-25.105-11.238-25.105-25.1c0-13.862 11.24-25.1 25.105-25.1s25.105 11.238 25.105 25.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEEC",
    d: "M288.471 108.166c0 12.178-9.874 22.05-22.055 22.05-12.18 0-22.056-9.872-22.056-22.05s9.875-22.05 22.056-22.05c12.18 0 22.055 9.872 22.055 22.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M265.294 90.781l-1.007 18.502a1.987 1.987 0 0 0 3.416 1.478 1.98 1.98 0 0 0 .543-1.486l-1.136-18.5c-.07-1.142-1.754-1.137-1.816.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M252.661 110.352l13.502 1.021a1.981 1.981 0 0 0 1.472-.547 1.987 1.987 0 0 0-.004-2.874c-.4-.378-.94-.572-1.489-.537l-13.493 1.121c-1.142.074-1.13 1.758.012 1.816"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAppointment);
export default __webpack_public_path__ + "static/media/requestAppointment.d0ed870f01490fedde780c780634c35e.svg";
export { ForwardRef as ReactComponent };